module.exports = __webpack_public_path__ + "static/media/trailer_yellow.42a1ff63.svg";